import axios from 'axios'
import { toast } from 'react-toastify';

    const API_URL = `${process.env.REACT_APP_API_URL}/posts`;

export const GET_POSTS = 'GET_POSTS';
export const CREATE_POST = 'CREATE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const GET_POST_BY_ID = 'GET_POST_BY_ID';

export const getPost = () => async (dispatch: any) => {
    try {
        const response = await axios.get(API_URL);
        console.log('Posts response:', response.data); // Debug için
        dispatch({
            type: GET_POSTS,
            payload: response.data
        });
    } catch (error: any) {
        console.error("Postlar getirilirken hata oluştu:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Postlar getirilirken bir hata oluştu");
    }
};

export const getPostById = (id: string) => async (dispatch: any) => {
    try {
        const response = await axios.get(`${API_URL}/${id}`);
        dispatch({
            type: GET_POST_BY_ID,
            payload: response.data
        });
    } catch (error: any) {
        console.error("Post getirilirken hata oluştu:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Post getirilirken bir hata oluştu");
    }
};

export const createPost = (formData: FormData) => async (dispatch: any) => {
    try {
        const response = await axios.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch({
            type: CREATE_POST,
            payload: response.data
        });
        toast.success("Post başarıyla oluşturuldu");
        return response.data;
    } catch (error: any) {
        console.error("Post oluşturulurken hata oluştu:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Post oluşturulurken bir hata oluştu");
        throw error;
    }
};

export const updatePost = (id: string, formData: FormData) => async (dispatch: any) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch({
            type: UPDATE_POST,
            payload: response.data
        });
        toast.success("Post başarıyla güncellendi");
        return response.data;
    } catch (error: any) {
        console.error("Post güncellenirken hata oluştu:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Post güncellenirken bir hata oluştu");
        throw error;
    }
};

export const deletePost = (id: string) => async (dispatch: any) => {
    try {
        await axios.delete(`${API_URL}/${id}`);
        dispatch({
            type: DELETE_POST,
            payload: id
        });
        toast.success("Post başarıyla silindi");
    } catch (error: any) {
        console.error("Post silinirken hata oluştu:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Post silinirken bir hata oluştu");
    }
};